var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { jsx } from '@emotion/core';
export function getInnerText(node) {
  if (node === null || typeof node === 'boolean') {
    return '';
  }

  if (typeof node === 'number') {
    return node.toString();
  }

  if (typeof node === 'string') {
    return node;
  }

  if (Array.isArray(node)) {
    return node.reduce(function (previous, current) {
      return previous + getInnerText(current);
    }, '');
  }

  var element = node;

  if (element.props && element.props.children) {
    return getInnerText(element.props.children);
  }

  return '';
}
export function applySearch(items, searchQuery) {
  var filteredItems = items.filter(function (item) {
    if (!searchQuery || !item.content) {
      return true;
    }

    var searchText = searchQuery.toLowerCase().replace(/ /g, '');
    var itemText = getInnerText(item.content).toLowerCase().replace(/\s/g, '');
    return itemText.includes(searchText);
  }).sort(function (a, b) {
    if (!searchQuery) {
      return 0;
    }

    var searchText = searchQuery.toLowerCase().replace(/ /g, '');
    var aText = getInnerText(a.content).toLowerCase().replace(/\s/g, '');
    var bText = getInnerText(b.content).toLowerCase().replace(/\s/g, '');
    var aStartsWithSearch = aText.startsWith(searchText);
    var bStartsWithSearch = bText.startsWith(searchText);

    if (aStartsWithSearch && bStartsWithSearch) {
      return aText.localeCompare(bText);
    } else if (aStartsWithSearch) {
      return -1;
    } else if (bStartsWithSearch) {
      return 1;
    } else {
      return aText.localeCompare(bText);
    }
  });
  return filteredItems;
} // Similar to clone elements, but using emotions jsx() function
// to clone as this let's us use the css prop

export function cloneElementWithCss(children, styles, props) {
  return jsx(children.type, __assign(__assign(__assign({
    key: children.key
  }, children.props), props), {
    css: styles
  }));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/shared/utils.js
// module id = 333
// module chunks = 0